import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ApiHandler from "./../../../../services/api/ApiHandler";
import apiPayload from './../../../../services/api/ApiPayload';
import CloudLoader from './../../loader/Loader_02';

const Code = ( contentData, initError, initLoader ) => {
  const location = useLocation();
  const navigate = useNavigate();
  let { data, loading, error, handlePostApi } = ApiHandler();
  const [isLoading, setIsLoading] = useState(false);  // For API loading
  const [serverError, setServerError] = useState(null);  // For API uniqueness errors
  const { p_result, p_name } = location.state || {};

  useEffect(() => {
    if (data && data.code === "200") {
      navigate('/connect');
    } else if (data && data.code !== "200") {
      setServerError({ general: 'Registration failed' });
    }
  }, [data, navigate]);

  const handleJoin = async () => {
    setIsLoading(true);
    setServerError(null);
    try {
      apiPayload.set('load.pageId', 'Page30004');
      apiPayload.set('load.redirectRoute', '/code-verification');
      apiPayload.set('load.data.userId', -1);
      apiPayload.set('load.data.loginCode', p_result.api_request_data.auth_code);
      apiPayload.set('load.data.coinRewardType', 1);
      handlePostApi("/v1/join/confirmation", apiPayload.fetchPayload());
    } catch (err) {
      setServerError({ general: 'API error', error: error });
      console.warn(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopy = () => {
    if (p_result) {
      navigator.clipboard.writeText(p_result.api_request_data.auth_code).then(() => {
        console.log('Copied to clipboard!');
      }).catch((err) => {
        console.error('Failed to copy: ', err);
      });
    }
  };

  return (
    <div>
        {initLoader && <CloudLoader />}
        {loading && <CloudLoader />}
        {isLoading && <CloudLoader />}
        {p_result.api_request_data.auth_code && <div className="alert-container success-indicator">
          <h2>Hi <strong className='important-alert'>{p_name || 'Unknown'}</strong>, Welcome to our platform!</h2>
          <br/>
          <h3>Your Access Code</h3>
          <h1 className='login-code'><strong>{p_result.api_request_data.auth_code || 'Unknown'}</strong></h1>
          <button onClick={handleCopy} className="clipboard-button">Copy Code</button>
        </div>}
        {p_result.api_request_data.auth_code && <div className="alert-container">
          <p><i>Save your access code</i></p>
          <button className="getting-started" onClick={handleJoin}><h3>Create Account</h3></button>
        </div>}
        {error && <span className="error">API Error : {error}</span>}
        {serverError?.general && <span className="error">{serverError.general}</span>}
    </div>
  );
};

export default Code;
